import type { IField } from '@moko/utils';
import { isContractorRole } from '@moko/utils/src/authHelper';

/**
 * Effective read-only state for a field, ignoring saved/view-only context.
 * `readonlyForContractors` only applies when the current session is a contractor,
 * so clients/managers/admins keep editing the field normally.
 */
export const isFieldReadOnly = (field: IField): boolean =>
  Boolean(
    field.readonly ||
      (field.readonlyForContractors && isContractorRole()) ||
      field.effect === 'Readonly'
  );
